export const AVAILABLE_TIME_OPTIONS = [
  {
    label: 'ทุกช่วงเวลา',
    value: 'ทุกช่วงเวลา',
  },
  {
    label: '8:30 - 12:00',
    value: '8:30 - 12:00',
  },
  {
    label: '12:00 - 13:00',
    value: '12:00 - 13:00',
  },
  {
    label: '13:00 - 17:00',
    value: '13:00 - 17:00',
  },
];

export const LCV_OPTIONS = [
  {
    label: 'รถปิกอัพ',
    value: 'pickup',
  },
  {
    label: 'รถมิว-เอ็กซ์',
    value: 'ppv',
  },
];
